import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import ClinicalNotes from './conditions';
import HealthGoals from './healthGoals';
import PersonalGoals from './personalGoals';

const PatientGoals = ({ canEditPage }) => (
  <Card className="card-border ccm-table-section">
    <CardBody>
      <h3 className="ccm-table-section__h3">Patient Self Directed Goals</h3>
      <div className="ccm-table-section__activities">
        <HealthGoals patientDetailsLoading={false} />
        <PersonalGoals patientDetailsLoading={false} />
        <ClinicalNotes canEditPage={canEditPage} />
      </div>
    </CardBody>
  </Card>
);

PatientGoals.propTypes = {
  canEditPage: PropTypes.bool,
};

export default PatientGoals;
